import {EdiSlashPoundCd} from '../';
import {EnumHelper} from './enum-helper';

export class EdiSlashPoundCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in EdiSlashPoundCd ) {
      this._values.push(EdiSlashPoundCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): EdiSlashPoundCd {

    for ( const obj in EdiSlashPoundCd ) {
      if (EdiSlashPoundCd[obj] === value){
        return EdiSlashPoundCd[obj] as EdiSlashPoundCd;
      }
    }
  }
}

const EdiSlashPoundCdHelper = new EdiSlashPoundCdHelperEnumHelperClass();
export default EdiSlashPoundCdHelper;
